import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

type AshbyAddress = {
  postalAddress: {
    addressRegion?: string;
    addressCountry?: string;
    addressLocality?: string;
  };
};
export type Job = {
  id: string;
  title: string;
  department: string;
  team: string;
  employmentType: string;
  location: string;
  shouldDisplayCompensationOnJobPostings: boolean;
  secondaryLocations: {
    location: string;
    address: AshbyAddress;
  }[];
  publishedAt: string;
  isListed: boolean;
  isRemote: boolean;
  address?: AshbyAddress;
  jobUrl: string;
  applyUrl: string;
  descriptionHtml: string;
  descriptionPlain: string;
  compensation: {
    compensationTierSummary?: string;
    scrapeableCompensationSalarySummary?: string;
    compensationTiers: {
      id: string;
      tierSummary: string;
      title: string;
      additionalInformation?: string;
      components: {
        id: string;
        summary?: string;
        compensationType?: string;
        interval?: string;
        currencyCode?: string;
        minValue?: number;
        maxValue?: number;
      }[];
    }[];
    summaryComponents: {
      compensationType?: string;
      interval?: string;
      currencyCode?: string;
      minValue?: number;
      maxValue?: number;
    }[];
  };
};
export enum FiltersEnum {
  Department = 'department',
  Team = 'team',
  Location = 'location',
  EmploymentType = 'employmentType',
}
export type FiltersType = { [key in FiltersEnum]: string[] };
export type JobListingsResponse = {
  jobs: Job[];
};

const ASHBY_LITE_API_URL =
  'https://api.ashbyhq.com/posting-api/job-board/hopper';

export const careersApi = createApi({
  reducerPath: 'careersApi',
  tagTypes: ['JobListings'],
  baseQuery: fetchBaseQuery({
    baseUrl: ASHBY_LITE_API_URL,
  }),
  endpoints: (build) => ({
    fetchJobListings: build.query<
      { jobs: Job[]; filters: FiltersType },
      { includeCompensation?: boolean }
    >({
      query: ({ includeCompensation }) => ({
        url: `?includeCompensation=${includeCompensation}`,
        method: 'GET',
      }),
      providesTags: ['JobListings'],
      transformResponse: (response: JobListingsResponse) => {
        const filters = {
          department: [],
          team: [],
          location: [],
          employmentType: [],
        };
        const fKeys = Object.keys(filters);
        response.jobs.forEach((job) => {
          fKeys.forEach((key) => {
            if (job[key] && !filters[key].includes(job[key])) {
              filters[key].push(job[key]);
            }
          });
        });

        return { jobs: response.jobs, filters };
      },
    }),
    // fetchJobListingsFull: build.query<Job[], { includeCompensation?: boolean }>(
    //   {
    //     query: ({ includeCompensation }) => ({
    //       url: `?includeCompensation=${includeCompensation}`,
    //       method: 'GET',
    //     }),
    //     providesTags: ['JobListings'],
    //     transformResponse: (response: JobListingsResponse) => {
    //       return response.jobs;
    //     },
    //   }
    // ),
  }),
});

export const { useFetchJobListingsQuery } = careersApi;
